<template>
  <div>
    <div class="px-5 sm:px-20 mt-10 pt-5" :class="{'!p-0 !mt-0': isModal}">
      <div class="font-medium text-base">
        การประกอบอาชีพ
      </div>
      <div
        class="grid grid-cols-12 gap-4 gap-y-5 mt-5 items-baseline"
        data-test="occupation-form"
      >
        <div class="col-span-12 sm:col-span-6 ">
          <RadioCustomButton
            class="w-60"
            name="occupation-status-radio-group"
            first-option-id="form-input-occupation-status-yes"
            second-option-id="form-input-occupation-status-no"
            :first-option-value="formOption.occupationOption[0].value"
            :second-option-value="formOption.occupationOption[1].value"
            :first-option-text="formOption.occupationOption[0].text"
            :second-option-text="formOption.occupationOption[1].text"
            v-model="validate.occup_status.$model"
            :class="{ 'border-theme-24': validate.occup_status.$error }"
          />
          <template v-if="validate.occup_status.$error">
            <div
            v-for="(error, index) in validate.occup_status.$errors"
            :key="index"
            class="text-theme-24 mt-1 text-xs"
            >
            {{ error.$message }}
            </div>
          </template>
        </div>
        <div class="col-span-12" v-if="form.occup_status == 1">
          <div class="grid grid-cols-12 gap-4 gap-y-5">
            <div class="font-medium text-base col-span-12">
              อาชีพหลัก
            </div>
            <div class="col-span-12 sm:col-span-6 ">
              <label
                class="form-label"
              >อาชีพหลัก</label>
                <!-- <treeselect data-test="main-career" v-model="validate.primary_occu_select.$model" :multiple="false" :searchable="false" :options="data_primary_career" placeholder="อาชีพหลัก" :class="{ 'border-1 border-theme-24 rounded-md': validate.primary_occu_select.$error }" :normalizer="normalizer">
                  <label slot="option-label" slot-scope="{ node }">
                    {{ node.label }}
                  </label>
                </treeselect> -->
                <v-select
                  :clearable="false"
                  data-test="main-career"
                  v-model="validate.primary_occup.$model"
                  :searchable="false"
                  :options="data_primary_career"
                  placeholder="อาชีพหลัก"
                  label="label"
                  :class="{ 'border-1 border-theme-24 rounded-md': validate.primary_occup.$error}"
                  :reduce="label => label.option"
                >
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                  </template>
                </v-select>
                <template v-if="validate.primary_occup.$error">
                  <div
                  class="text-theme-24 mt-1 text-xs"
                  >
                  {{ validate.primary_occup.required.$message}}
                  </div>
                </template>
            </div>
            <div class="col-span-12 sm:col-span-6" v-if="form.primary_occup && form.primary_occup.desc == 'อื่นๆ'">
              <label
                class="form-label"
              >อื่นๆ</label>
              <input
                type="text"
                class="form-control"
                placeholder="กรุณาระบุ"
                data-test="other-career"
                v-model="form.primary_occup.occu_name"
                v-model.trim="validate.primary_occup.occu_name.$model"
                :class="{ 'border-1 border-theme-24 rounded-md': validate.primary_occup.occu_name.$error || validate.primary_occup.occu_name.$invalid }"
              >
              <template v-if="validate.primary_occup.occu_name.$error || validate.primary_occup.occu_name.$invalid">
                <div class="text-theme-24 mt-1 text-xs">
                  {{validate.primary_occup.occu_name.required.$message}}
                </div>
              </template>
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label
                class="form-label"
              >รายได้เดือนละ (บาท)</label>
              <input
                type="number"
                min="0"
                class="form-control"
                placeholder="กรุณาระบุจำนวนเงิน"
                data-test="main-salary"
                v-model="validate.pri_occup_income.$model"
                :class="{ 'border-1 border-theme-24 rounded-md': validate.pri_occup_income.$error }"
              >
              <template v-if="validate.pri_occup_income.$error">
                <div
                v-for="(error, index) in validate.pri_occup_income.$errors"
                :key="index"
                class="text-theme-24 mt-1 text-xs"
                >
                {{ error.$message }}
                </div>
              </template>
            </div>
            <hr class="col-span-12">
            <div class="font-medium text-base col-span-12">
              อาชีพรอง <span>(ตอบได้มากกว่า 1 ข้อ)</span>
            </div>
            <div
              class="col-span-12 md:col-span-6"
              v-for="(data,key) in data_secondary_career"
              :key="key"
            >
              <div
                class="form-checkbox-custom sm:flex pl-6"
              >
                <div class="mr-3">
                  <label
                    class="form-check-label align-middle"
                    :for="`form-input-sec-career-${key}`"
                  >
                  <input
                    :id="`form-input-sec-career-${key}`"
                    class="form-check-input align-middle"
                    type="checkbox"
                    :value="data.option"
                    v-model="form.secondary_occup"
                  >
                  {{data.option.desc}}
                  </label>
                </div>
                <div class="form-input-for-checkbox" v-if="data.specify && form.secondary_occup.some(({code})=> code == data.option.code)">
                  <input
                    type="text"
                    class="form-control mt-2"
                    placeholder="กรุณาระบุ"
                    data-test="form-other-sec-career"
                    v-model="validate.secondary_occup.$model[form.secondary_occup.findIndex(p => p.code == data.option.code)].occu_name"
                    :class="{ 'border-1 border-theme-24 rounded-md': validate.secondary_occup.$each.$response.$errors[form.secondary_occup.findIndex(p => p.code == data.option.code)].occu_name.length}"
                  >
                  <template v-if="validate.secondary_occup.$each.$response.$errors[form.secondary_occup.findIndex(p => p.code == data.option.code)].occu_name.length">
                    <div
                      v-for="(error, index) in validate.secondary_occup.$each.$response.$errors[form.secondary_occup.findIndex(p => p.code == data.option.code)].occu_name"
                      :key="index"
                      class="text-theme-24 mt-1 text-xs"
                    >
                      {{ error.$message }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div
              class="col-span-12"
            >
              <div class="grid grid-cols-12">
                <div class="col-span-12 sm:col-span-6">
                  <label
                    class="form-label"
                  >รายได้เดือนละ (บาท)</label>
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    placeholder="กรุณาระบุจำนวนเงิน"
                    data-test="secondary-salary"
                    v-model="validate.sec_occup_income.$model"
                    :class="{ 'border-1 border-theme-24 rounded-md': validate.sec_occup_income.$error }"
                  >
                  <template v-if="validate.sec_occup_income.$error">
                    <div
                    v-for="(error, index) in validate.sec_occup_income.$errors"
                    :key="index"
                    class="text-theme-24 mt-1 text-xs"
                    >
                    {{ error.$message }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12" v-if="form.occup_status == 0">
          <div class="grid grid-cols-12 gap-4 gap-y-5">
            <div class="font-medium text-base col-span-12">
              ไม่ประกอบอาชีพ
            </div>
            <div
              class="col-span-12 sm:col-span-6"
            >
              <div :class="{ 'border-1 border-theme-24 rounded-md p-2': validate.get_subsidy.$error }" >
                <div class="form-check-input-indent mr-2" v-for="(data,key) in formOption.noOccupationOption" :key="key" :class="{'mt-5':key>0}">
                  <input
                    :id="`form-input-no-career-status-${key}`"
                    class="form-check-input align-middle"
                    type="radio"
                    v-model="validate.get_subsidy.$model"
                    :value="data.value"
                  >
                  <label
                    class="form-check-label align-middle"
                    :for="`form-input-no-career-status-${key}`"
                  >{{data.text}}</label>
                  <div
                    class="mt-5"
                    v-if="data.specify && form.get_subsidy == 1"
                  >
                    <label class="ml-6">เดือนละ (บาท)</label>
                    <input
                      type="number"
                      min="0"
                      class="form-control mt-2"
                      placeholder="กรุณาระบุจำนวนเงิน"
                      data-test="form-subsidy-1st"
                      v-model="validate.subsidy_amount.$model"
                      :class="{ 'border-1 border-theme-24 rounded-md': validate.subsidy_amount.$error || validate.subsidy_amount.$invalid }"
                    >
                    <template v-if="validate.subsidy_amount.$error || validate.subsidy_amount.$invalid">
                      <div class="text-theme-24 mt-1 text-xs ml-6">
                        {{validate.subsidy_amount.required.$message}}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <template v-if="validate.get_subsidy.$error">
                <div
                v-for="(error, index) in validate.get_subsidy.$errors"
                :key="index"
                class="text-theme-24 mt-1 text-xs"
                >
                {{ error.$message }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <hr class="col-span-12">
        <div class="font-medium text-base col-span-12">
          รายจ่าย/ทรัพย์สิน/หนี้สิน
        </div>
        <div class="col-span-12">
          <label class="form-label">
            รายจ่ายประจำเดือน (ตอบได้มากกว่า 1 ข้อ) <span class="font-bold">รวม {{new Intl.NumberFormat().format(form.SUM_EXPENDITURE)}} บาท/เดือน</span>
          </label>
        </div>
        <div
          class="col-span-12 sm:col-span-6"
          v-for="(data,key) in data_expenditure"
          :key="key"
        >
          <div
            class="form-checkbox-custom sm:flex pl-6"
          >
            <div class="mr-3">
              <label
                class="form-check-label align-middle"
                :for="`form-input-expense-${key}`"
              >
              <input
                :id="`form-input-expense-${key}`"
                class="form-check-input align-middle"
                type="checkbox"
                :value="data.option"
                v-model="form.expenditure"
              >{{data.option.desc}}</label>
            </div>
            <div class="form-input-for-checkbox" v-if="data.specify && form.expenditure.some(({code})=> code == data.option.code)">
              <input
                type="number"
                min="0"
                class="form-control"
                placeholder="กรุณาระบุจำนวน"
                v-model="form.expenditure[form.expenditure.findIndex(p => p.code == data.option.code)].amount"
                :class="{ 'border-1 border-theme-24 rounded-md': validate.expenditure.$each.$response.$errors[form.expenditure.findIndex(p => p.code == data.option.code)].amount.length}"
              >
              <template v-if="validate.expenditure.$each.$response.$errors[form.expenditure.findIndex(p => p.code == data.option.code)].amount.length">
                <div
                  v-for="(error, index) in validate.expenditure.$each.$response.$errors[form.expenditure.findIndex(p => p.code == data.option.code)].amount"
                  :key="index"
                  class="text-theme-24 mt-1 text-xs"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
          </div>
          <div
            v-if="data.plusMore && form.expenditure.some(({code})=> code == data.option.code)"
          >
            <div class="flex ml-6" v-for="(d, k) in formInput.expenditure_other" :key="k">
              <div class="mr-1">
                <input
                  type="text"
                  class="form-control"
                  placeholder="กรุณาระบุรายการ"
                  data-test="form-input-other"
                  style="height:38px;"
                  v-model="d.expenditure_name"
                  :class="{ 'border-1 border-theme-24 rounded-md':  validate_group.expenditure_other.$each.$response.$errors[k].expenditure_name.length}"
                >
                <template v-if="validate_group.expenditure_other.$each.$response.$errors[k].expenditure_name.length">
                  <div
                  v-for="(error, index) in validate_group.expenditure_other.$each.$response.$errors[k].expenditure_name"
                  :key="index"
                  class="text-theme-24 mt-1 text-xs"
                  >
                  {{ error.$message }}
                  </div>
                </template>
              </div>
              <div class="mr-1">
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  :placeholder="`กรุณาระบุจำนวน`"
                  data-test="form-input-other-amount"
                  style="height:38px;"
                  v-model="d.amount"
                  :class="{ 'border-1 border-theme-24 rounded-md': validate_group.expenditure_other.$each.$response.$errors[k].amount.length}"
                >
                <template v-if="validate_group.expenditure_other.$each.$response.$errors[k].amount.length">
                  <div
                  v-for="(error, index) in validate_group.expenditure_other.$each.$response.$errors[k].amount"
                  :key="index"
                  class="text-theme-24 mt-1 text-xs"
                  >
                  {{ error.$message }}
                  </div>
                </template>
              </div>
              <div>
                <button class="btn btn-primary mr-1 mb-2" @click="addMoreItem('expenditure_other')" v-if="k==formInput['expenditure_other'].length-1">
                  <PlusIcon class="w-5 h-5" />
                </button>
                <button class="btn btn-danger mr-1 mb-2" @click="removeItem('expenditure_other', k)" v-else>
                  <MinusIcon class="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12">
          <label class="form-label">
            ทรัพย์สิน (ตอบได้มากกว่า 1 ข้อ)
          </label>
        </div>
        <div
          class="col-span-12 sm:col-span-6"
          data-test="property"
          v-for="(data,key) in formOption.propertyOption"
          :key="key"
        >
            <div class="form-checkbox-custom sm:flex pl-6">
              <div class="mr-3">
                <label
                  class="form-check-label align-middle ml-0"
                  :for="`form-input-property-${key}`"
                >
                  <input
                    :id="`form-input-property-${key}`"
                    class="form-check-input align-middle"
                    type="checkbox"
                    :value="data.name"
                    v-model="form.assetChoose"
                  > {{data.text}}
                </label>
              </div>
              <div class="form-input-for-checkbox" v-if="data.specify && form.assetChoose.includes(data.name)">
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="กรุณาระบุจำนวน (บาท)"
                  :data-test="`form-input-property-${key}`"
                  v-model="form.asset[data.name]"
                  v-model.trim="validate.asset[data.name].$model"
                 :class="{ 'border-1 border-theme-24 rounded-md': validate.asset[data.name].$error || validate.asset[data.name].$invalid}"
                >
                <template v-if="validate.asset[data.name].$invalid || validate.asset[data.name].$error">
                  <div class="text-theme-24 mt-1 text-xs">
                    {{validate.asset[data.name].required.$message}}
                  </div>
                </template>
              </div>
            </div>
            <div
              class="mt-5"
              v-if="data.choices && form.assetChoose.includes(data.name)"
            >
              <div class="ml-6" :class="{ 'border-1 border-theme-24 rounded-md p-2' : validate.asset[data.name].$invalid || validate.asset[data.name].$error}">
                <div class="form-checkbox-custom sm:flex pl-6" :class="{'mt-5':key2>0}" v-for="(choice, key2) in data.choices" :key="key2">
                  <div class="mr-3">
                    <label
                      class="form-check-label align-middle ml-0"
                      :for="`form-input-property-choice-${key2}`"
                    >
                      <input
                        :id="`form-input-property-choice-${key2}`"
                        class="form-check-input align-middle"
                        type="checkbox"
                        :value="choice"
                        v-model="form.asset[data.name]"
                        @change="validate.asset[data.name].$touch()"
                      > {{choice.type}}
                    </label>
                  </div>
                  <div class="form-input-for-checkbox" v-if="form.asset[data.name].some(({type})=> type == choice.type)">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      placeholder="กรุณาระบุจำนวน (ไร่)"
                      :data-test="`form-input-property-choice-${key2}`"
                      v-model="form.asset[data.name][form.asset[data.name].findIndex(p => p.type == choice.type)].amount"
                    >
                  </div>
                </div>
              </div>
              <template v-if="validate.asset[data.name].$invalid || validate.asset[data.name].$error">
                <div class="text-theme-24 mt-1 text-xs ml-6">
                    {{validate.asset[data.name].required.$message}}
                </div>
              </template>
            </div>
            <div
              v-if="data.plusMore && form.assetChoose.includes(data.name)"
            >
              <div class="flex ml-6" v-for="(d, k) in formInput[data.name]" :key="k">
                <div class="mr-1">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรายการ"
                    :data-test="`form-input-asset-other-${k}`"
                    style="height:38px;"
                    v-model="d.type"
                    :class="{ 'border-1 border-theme-24 rounded-md':  validate_group[data.name].$each.$response.$errors[k].type.length}"
                  >
                  <template v-if="validate_group[data.name].$each.$response.$errors[k].type.length">
                    <div
                    v-for="(error, index) in validate_group[data.name].$each.$response.$errors[k].type"
                    :key="index"
                    class="text-theme-24 mt-1 text-xs"
                    >
                    {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div class="mr-1">
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    :placeholder="`กรุณาระบุจำนวน (${data.placeText})`"
                    :data-test="`form-input-asset-other-amount-${k}`"
                    style="height:38px;"
                    v-model="d.amount"
                    :class="{ 'border-1 border-theme-24 rounded-md':  validate_group[data.name].$each.$response.$errors[k].amount.length}"
                  >
                  <template v-if="validate_group[data.name].$each.$response.$errors[k].amount.length">
                    <div
                    v-for="(error, index) in validate_group[data.name].$each.$response.$errors[k].amount"
                    :key="index"
                    class="text-theme-24 mt-1 text-xs"
                    >
                    {{ error.$message }}
                    </div>
                  </template>
                </div>
                <div>
                  <button class="btn btn-primary mr-1 mb-2" @click="addMoreItem(data.name)" v-if="k==formInput[data.name].length-1">
                    <PlusIcon class="w-5 h-5" />
                  </button>
                  <button class="btn btn-danger mr-1 mb-2" @click="removeItem(data.name, k)" v-else>
                    <MinusIcon class="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
        </div>
        <div class="col-span-12">
          <label class="form-label">
            การออมประจำเดือน (ตอบได้มากกว่า 1 ข้อ) <span class="font-bold">รวม {{new Intl.NumberFormat().format(form.SUM_SAVING)}} บาท/เดือน</span>
          </label>
        </div>
        <div
          class="col-span-12 sm:col-span-6"
          v-for="(data, key) in data_saving"
          :key="key"
        >
          <div class="form-checkbox-custom sm:flex pl-6" >
            <div class="mr-3">
              <label
                class="form-check-label align-middle"
                :for="`form-input-saving-${data.option.code}`"
              >
                <input
                  :id="`form-input-saving-${data.option.code}`"
                  class="form-check-input align-middle"
                  type="checkbox"
                  :value="data.option"
                  v-model="form.saving"
                > {{data.option.desc}}
              </label>
            </div>
            <div class="form-input-for-checkbox" v-if="data.specify && form.saving.some(({code})=> code == data.option.code)">
              <input
                type="number"
                min="0"
                class="form-control"
                placeholder="กรุณาระบุจำนวนเงิน"
                :data-test="`other-saving-${key}`"
                v-model="form.saving[form.saving.findIndex(p => p.code == data.option.code)].amount"
                :class="{ 'border-1 border-theme-24 rounded-md': validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].amount.length}"
              >
              <template v-if="validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].amount.length">
                <div
                  v-for="(error, index) in validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].amount"
                  :key="index"
                  class="text-theme-24 mt-1 text-xs"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
          </div>
          <div
            class="flex ml-6"
            v-if="data.plusMore && form.saving.some(({code})=> code == data.option.code)"
          >
            <div class="mr-1">
              <input
                type="text"
                class="form-control"
                placeholder="กรุณาระบุรายการ"
                data-test="form-input-saving-other"
                style="height:38px;"
                v-model="form.saving[form.saving.findIndex(p => p.code == data.option.code)].saving_name"
                :class="{ 'border-1 border-theme-24 rounded-md': validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].saving_name.length}"
              >
              <template v-if="validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].saving_name.length">
                <div
                  v-for="(error, index) in validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].saving_name"
                  :key="index"
                  class="text-theme-24 mt-1 text-xs"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
            <div class="mr-1">
              <input
                type="number"
                min="0"
                class="form-control"
                placeholder="กรุณาระบุจำนวนเงิน"
                data-test="form-input-saving-other-amount"
                style="height:38px;"
                v-model="form.saving[form.saving.findIndex(p => p.code == data.option.code)].amount"
                :class="{ 'border-1 border-theme-24 rounded-md': validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].amount.length}"
              >
              <template v-if="validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].amount.length">
                <div
                  v-for="(error, index) in validate.saving.$each.$response.$errors[form.saving.findIndex(p => p.code == data.option.code)].amount"
                  :key="index"
                  class="text-theme-24 mt-1 text-xs"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-span-12">
          <label class="form-label">
            หนี้สินประจำเดือน (ตอบได้มากกว่า 1 ข้อ) <span class="font-bold">รวม {{new Intl.NumberFormat().format(form.SUM_DEBT)}} บาท/เดือน</span>
          </label>
        </div>
        <div class="col-span-12">
          <RadioCustomButton
            class="w-40"
            name="debt-radio-group"
            first-option-id="form-input-debt-status-yes"
            second-option-id="form-input-debt-status-no"
            :first-option-value="formOption.debtStatusOption[0].value"
            :second-option-value="formOption.debtStatusOption[1].value"
            :first-option-text="formOption.debtStatusOption[0].text"
            :second-option-text="formOption.debtStatusOption[1].text"
            v-model="form.have_debt"
          />
        </div>
        <div class="col-span-12" v-if="form.have_debt == 1">
          <div class="grid grid-cols-12 gap-4 gap-y-5" :class="{ 'border-1 border-theme-24 rounded-md p-2': validate.debt.$error }">
            <div
              class="col-span-12 sm:col-span-6"
              v-for="(data, key) in formOption.debtOption"
              :key="key"
            >
              <div class="form-checkbox-custom sm:flex pl-6">
                <div class="mr-3">
                  <label
                    class="form-check-label align-middle"
                    :for="`form-input-debt-${key}`"
                  >
                    <input
                      :id="`form-input-debt-${key}`"
                      class="form-check-input align-middle"
                      type="checkbox"
                      :value="data"
                      v-model="form.debt"
                      @change="validate.debt.$touch()"
                    >{{data.type}}
                  </label>
                </div>
                <div class="form-input-for-checkbox" v-if="form.debt.some(({type})=> type == data.type)">
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    placeholder="กรุณาระบุจำนวน (บาท/เดือน)"
                    v-model="form.debt[form.debt.findIndex(p => p.type == data.type)].amount"
                    :data-test="`other-debt-${key}`"
                  >
                </div>
              </div>
            </div>
          </div>
          <template v-if="validate.debt.$error">
            <div
              class="text-theme-24 mt-1 text-xs"
            >
              {{ validate.debt.required.$message }}
            </div>
          </template>
        </div>
      </div>
      <hr class="col-span-12 mt-10">
    </div>
    <div
    class="col-span-12 flex items-center mt-10 justify-end"
    v-if="isModal"
    >
        <div>
            <button
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="cancelModalButton"
            >
            ยกเลิก
            </button>
            <button
            class="btn btn-primary ml-2"
            @click="nextStep"
            >
            บันทึก
            </button>
        </div>
    </div>
    <div
      class="col-span-12 flex items-center mt-10 px-5 sm:px-20 justify-between"
      v-else
    >
      <div>
          <button
          class="btn btn-secondary"
          @click="closeWizardForm"
          >
          ออก
          </button>
          <button
          class="btn btn-secondary ml-2"
          @click="skipStep"
          >
          ข้าม
          </button>
      </div>
      <div>
          <button
          class="btn btn-secondary ml-2"
          @click="prevStep"
          >
          ย้อนกลับ
          </button>
          <button
          class="btn btn-primary ml-2"
          @click="nextStep"
          >
          บันทึกและถัดไป
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive,defineComponent, watch, ref, toRefs } from 'vue'
import dataJson from '@/data/general.json'
import RadioCustomButton from '@/components/base/radio-custom-button/index.vue'
// import Treeselect from 'vue3-treeselect'
// import 'vue3-treeselect/dist/vue3-treeselect.css'
import useVuelidate from '@vuelidate/core'
import { required, helpers, requiredIf } from '@vuelidate/validators'
import Swal from 'sweetalert2'
import axios from "axios"
import { useStore } from 'vuex'
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
export default defineComponent({
  props:{
    isModal:{
      type: Boolean,
      default: false
    },
    updateId:{
      type: String
    },
    editData:{
      type: Object
    },
    cancelModal:{
      type: Boolean,
      default: false
    },
    openModal:{
      type: Boolean,
      default: false
    }
  },
  components:{
    RadioCustomButton
  },
  setup(props,{emit}){
    const formOption = reactive({
        occupationOption:[
          {text: "ประกอบอาชีพ", value: 1},
          {text: "ไม่ประกอบอาชีพ", value: 0}
        ],
        noOccupationOption:[
          {text: "ผู้อื่นสนับสนุน", value: 1, specify: true},
          {text: "สวัสดิการ", value: 2}
        ],
        debtStatusOption:[
          {text: "มีหนี้", value: 1},
          {text: "ไม่มีหนี้", value: 0}
        ],
        propertyOption:[
          {
            text: "ที่ดิน (ตอบได้มากกว่า 1 ข้อ)",
            name: "land",
            choices:
            [
              {type: "อาศัย",amount: null},
              {type: "เพื่อทำกิน",amount:null},
            ]
          },
          {
            text: "ทอง",
            specify: true,
            name: "gold"
          },
          {
            text: "สัตว์เศรษฐกิจ",
            plusMore: true,
            placeText:"ตัว",
            name: "livestock"
          },
          {
            text: "สิ่งปลูกสร้าง",
            plusMore: true,
            placeText:"หลัง",
            name: "building"
          },
          {
            text: "เครื่องจักร",
            plusMore: true,
            placeText:"เครื่อง",
            name: "machinery"
          },
        ],
        debtOption:[
          {
            type:"ในระบบ", amount:null
          },
          {
            type:"นอกระบบ", amount: null
          }
        ],
    })
    const data_expenditure = reactive(dataJson.expenditure)
    const data_saving = reactive(dataJson.saving)
    const data_secondary_career = reactive(dataJson.secondary_career)
    const data_primary_career = reactive(dataJson.primary_career)
    const form = reactive({
      occup_status: null,
      primary_occup: null,
      // primary_occu_select: null,
      pri_occup_income: null,
      sec_occup_income: null,
      get_subsidy: null,
      subsidy_amount: null,
      expenditure: [],
      secondary_occup: [],
      saving:[],
      debt: [],
      SUM_EXPENDITURE : 0,
      SUM_SAVING: 0,
      SUM_DEBT: 0,
      SUM_INCOME: 0,
      assetChoose:[],
      asset: {
        // gold: null,
        land:[],
        // livestock:[],
        // building:[],
        // machinery: []
      },
      have_debt: null
    })
    const formDefault = reactive({
      occup_status: null,
      primary_occup: null,
      // primary_occu_select: null,
      pri_occup_income: null,
      sec_occup_income: null,
      get_subsidy: null,
      subsidy_amount: null,
      expenditure: [],
      secondary_occup: [],
      saving:[],
      debt: [],
      SUM_EXPENDITURE : 0,
      SUM_SAVING: 0,
      SUM_DEBT: 0,
      SUM_INCOME: 0,
      assetChoose:[],
      asset: {
        // gold: null,
        land:[],
        // livestock:[],
        // building:[],
        // machinery: []
      },
      have_debt: null
    })
    const formInput = reactive({
      livestock:[],
      building:[],
      machinery: [],
      expenditure_other: [],
      land: []
    })
    const currStep = ref(2)
    const rules = {
      occup_status: {
          required: helpers.withMessage(`กรุณาเลือกการประกอบอาชีพ`, required)
      },
      // primary_occu_select:{
      //   required: helpers.withMessage(`กรุณาเลือกอาชีพหลัก`, requiredIf(()=>form.occup_status==1))
      // },
      primary_occup:{
        required: helpers.withMessage(`กรุณาเลือกอาชีพหลัก`, requiredIf(()=>form.occup_status==1)),
        occu_name:{
          required: helpers.withMessage(`กรุณาระบุ`, requiredIf(()=>form.occup_status==1&&form.primary_occup.desc=='อื่นๆ'))
        }
      },
      pri_occup_income:{
        required: helpers.withMessage(`กรุณากรอกรายได้หลัก`, requiredIf(()=>form.occup_status==1))
      },
      sec_occup_income:{
        required: helpers.withMessage(`กรุณากรอกรายได้รอง`, requiredIf(()=>(form.secondary_occup.length>0&&form.occup_status==1)))
      },
      secondary_occup:{
        $each: helpers.forEach({
            occu_name: {
              required: helpers.withMessage(`กรุณาระบุ`, required)
            }
        })
      },
      get_subsidy: {
        required: helpers.withMessage(`กรุณาเลือก`, requiredIf(()=>form.occup_status==0))
      },
      subsidy_amount:{
        required: helpers.withMessage(`กรุณาระบุจำนวน`, requiredIf(()=>form.get_subsidy==1&&form.occup_status==0))
      },
      debt:{
        required: helpers.withMessage(`กรุณาระบุ`, requiredIf(()=>form.have_debt==1)),
        $each: helpers.forEach({
            amount: {
              required: helpers.withMessage(`กรุณาระบุ`, required)
            }
        })
      },
      asset:{
        gold:{
          required: helpers.withMessage(`กรุณาระบุจำนวน`, requiredIf(()=>form.assetChoose.includes('gold')))
        },
        land:{
          required: helpers.withMessage(`กรุณาเลือกและระบุจำนวนให้ครบถ้วน`, requiredIf(()=>form.assetChoose.includes('land'))),
          $each: helpers.forEach({
            amount: {
              required: helpers.withMessage(`กรุณาระบุจำนวน`, required)
              // required: helpers.withMessage(`กรุณาระบุจำนวน`, requiredIf(()=>form.assetChoose.includes('land') && form.asset.land.some(({amount})=> amount == null || amount == "")))
            }
          })
        },
      },
      expenditure: {
        $each: helpers.forEach({
          amount: {
            required: helpers.withMessage(`กรุณาระบุจำนวน`, required)
          },
        })
      },
      saving: {
        $each: helpers.forEach({
          amount: {
            required: helpers.withMessage(`กรุณาระบุจำนวน`, required)
          },
          saving_name: {
            required: helpers.withMessage(`กรุณาระบุรายการ`, required)
          }
        })
      }
    }
    const rules_group = {
      expenditure_other:{
        $each: helpers.forEach({
          expenditure_name:{
            required: helpers.withMessage(`กรุณาระบุรายการ`, required)
          },
          amount:{
            required: helpers.withMessage(`กรุณาระบุจำนวน`, required)
          }
        })
      },
      livestock:{
        $each: helpers.forEach({
          type:{
            required: helpers.withMessage(`กรุณาระบุรายการ`, required)
          },
          amount:{
            required: helpers.withMessage(`กรุณาระบุจำนวน`, required)
          }
        })
      },
      building:{
        $each: helpers.forEach({
          type:{
            required: helpers.withMessage(`กรุณาระบุรายการ`, required)
          },
          amount:{
            required: helpers.withMessage(`กรุณาระบุจำนวน`, required)
          }
        })
      },
      machinery:{
        $each: helpers.forEach({
          type:{
            required: helpers.withMessage(`กรุณาระบุรายการ`, required)
          },
          amount:{
            required: helpers.withMessage(`กรุณาระบุจำนวน`, required)
          }
        })
      }
    }
    const validate = useVuelidate(rules, toRefs(form))
    const validate_group = useVuelidate(rules_group, formInput)
    const store = useStore()
    const token = store.getters["userAuth/getToken"];
    watch(
      () => form.expenditure,
      (val,old) => {
        //check has other checked for new val & compare with old val
        if(val.some(({code}) => code == "XP12") && !old.some(({code}) => code == "XP12") && formInput.expenditure_other.length == 0){
          formInput.expenditure_other.push({expenditure_name: null, amount:null})
        }
        if(!val.some(({code}) => code == "XP12")){//uncheck other clear value in expenditure other
          formInput.expenditure_other = reactive([])
        }
        form.SUM_EXPENDITURE = 0
        form.expenditure.forEach((obj)=>{
          var rawData = JSON.parse(JSON.stringify(obj));
          if(rawData.amount){
            form.SUM_EXPENDITURE += rawData.amount

          }
          if(rawData.expenditure_other){
            rawData.expenditure_other.forEach((item)=>{
              form.SUM_EXPENDITURE += item.amount
            })
          }
        })
        let checked_lst = [...form.expenditure]
        //set data amount to null when uncheck
        data_expenditure.forEach((item)=>{
          if(!checked_lst.includes(item.option) && item.option.code != "XP12"){
            item.option.amount = null
          }
        })
      },
      {deep: true}
    )
    watch(
      () => form.saving,
      () => {
        form.SUM_SAVING = 0
        form.saving.forEach((obj)=>{
          if(obj.amount){
            form.SUM_SAVING += obj.amount
          }
        })
        let checked_lst = [...form.saving]
        //set data amount to null when uncheck
        data_saving.forEach((item)=>{
          if(!checked_lst.includes(item.option) && item.option.code != "SV6"){
            item.option.amount = null
            if(item.option.code == "SV7"){
              item.option.saving_name = null
            }
          }
        })
      },
      {deep: true}
    )
    watch(
      () => form.debt,
      () => {
        form.SUM_DEBT = 0
        form.debt.forEach((obj)=>{
          if(obj.amount){
            form.SUM_DEBT += obj.amount
          }
        })
        let checked_lst = [...form.debt]
        //set data amount to null when uncheck
        formOption.debtOption.forEach((item)=>{
          if(!checked_lst.includes(item)){
            item.amount = null
          }
        })
      },
      {deep: true}
    )
    watch(
      ()=> formInput.expenditure_other,()=>{
        let index = form.expenditure.findIndex(obj => obj.code == "XP12")
        if(index != -1){
          form.expenditure[index]['expenditure_other'] = reactive([])
          formInput.expenditure_other.forEach((obj)=>{
            if(obj.amount){
              form.expenditure[index]['expenditure_other'].push(obj)
            }
          })
        }
      },
      {deep: true}
    )
    watch(
      ()=> formInput.livestock,(val)=>{
        if(val.length == 0){
          delete form.asset.livestock
        }
        if(val.length>0){
          form.asset.livestock = reactive([])
          formInput.livestock.forEach((obj)=>{
            if(obj.amount){
              form.asset.livestock.push(obj)
            }
          })
        }
      },
      {deep: true}
    )
    watch(
      ()=> formInput.building,(val)=>{
        if(val.length == 0){
          delete form.asset.building
        }
        if(val.length>0){
          form.asset.building = reactive([])
          formInput.building.forEach((obj)=>{
            if(obj.amount){
              form.asset.building.push(obj)
            }
          })
        }
      },
      {deep: true}
    )
    watch(
      ()=> formInput.machinery,(val)=>{
        if(val.length == 0){
          delete form.asset.machinery
        }
        if(val.length>0){
          form.asset.machinery = reactive([])
          formInput.machinery.forEach((obj)=>{
            if(obj.amount){
              form.asset.machinery.push(obj)
            }
          })
        }
      },
      {deep: true}
    )
    watch(
      ()=> form.assetChoose, (val,old)=>{
        if(val.includes("livestock") && !old.includes("livestock") && formInput.livestock.length == 0){
            formInput.livestock.push({type: null, amount:null})
        }
        else if(!val.includes("livestock")){
          formInput.livestock = reactive([])
        }
        if(val.includes("building") && !old.includes("building") && formInput.building.length == 0){
            formInput.building.push({type: null, amount:null})
        }
        else if(!val.includes("building")){
          formInput.building = reactive([])
        }
        if(val.includes("machinery") && !old.includes("machinery") && formInput.machinery.length == 0){
            formInput.machinery.push({type: null, amount:null})
        }
        else if(!val.includes("machinery")){
          formInput.machinery = reactive([])
        }
        if(!val.includes("land")){
          form.asset.land = []
          formInput.land = reactive([])
          formInput.land = reactive([
              {type: "อาศัย",amount:null},
              {type: "เพื่อทำกิน",amount:null}
          ])
        }
        if(!val.includes("gold")){
          delete form.asset.gold
        }
      }
    )
    //clear value if change choice radio
    watch(()=>form.occup_status,(val)=>{
      if(val == 1){
        form.subsidy_amount = null
        form.get_subsidy = null
      }
      else{
        form.primary_occup = null
        form.pri_occup_income = null
        form.sec_occup_income = null
        form.secondary_occup = []
      }
    })
    watch(()=>form.have_debt,(val)=>{
      if(val == 0){
        form.debt = []
      }
    })
    /*watch(()=> form.primary_occu_select,(val)=>{
      if(val){
        console.log("val ",val);
        form.primary_occup = val
        // if(val.code == "OC9"){
        //   delete form.primary_occu_select.occu_name
        //   console.log("del ", form.primary_occu_select);
        // }
      }else{
        delete form.primary_occup.code
        delete form.primary_occup.desc
      }
    })
    console.log("asset ", form.asset.land);
    function primaryChange(val){
      form.primary_occup = val.option
    }*/
    function addMoreItem(name){
      if(name == "expenditure_other")
        formInput[name].push({expenditure_name: null, amount:null})
      else
        formInput[name].push({type:null, amount:null})
    }
    function removeItem(name, idx){
      formInput[name].splice(idx, 1)
    }
    function nextStep(){
      validate.value.$touch()
      validate_group.value.$touch()
      if (validate.value.$invalid || validate_group.value.$invalid) {
        return;
      }
      if(Object.keys(form.asset).length > 0){//always have key land check empty before send
        if(form.asset.land?.length == 0){
          delete form.asset.land
        }
      }
      const config = {
        url: `${process.env.VUE_APP_BASE_API}member/${props.isModal ? props.editData._id : props.updateId}`,
        method: "PUT",
        headers:{
          Authorization: `Bearer ${token}`,
          "Content-Type": `application/json; charset=utf-8`,
        },
        data:{
          update:{
            "occup_status": form.occup_status,
            "primary_occup": form.primary_occup,
            "secondary_occup": form.secondary_occup?.length > 0 ? form.secondary_occup : null,
            "pri_occup_income": form.pri_occup_income,
            "sec_occup_income": form.sec_occup_income ? form.sec_occup_income : null,
            "get_subsidy": form.get_subsidy,
            "subsidy_amount": form.subsidy_amount,
            "SUM_INCOME": form.pri_occup_income + (form.sec_occup_income ? form.sec_occup_income: 0),
            "expenditure": form.expenditure.length > 0 ? form.expenditure : null,
            "SUM_EXPENDITURE": form.SUM_EXPENDITURE,
            "saving": form.saving?.length > 0 ? form.saving : null,
            "SUM_SAVING": form.SUM_SAVING,
            "have_debt": form.have_debt,
            "debt": form.debt?.length > 0 ? form.debt : null,
            "SUM_DEBT": form.SUM_DEBT,
            "asset": Object.keys(form.asset)?.length > 0 ? form.asset : null
          }
        }
      };
      if(props.isModal){
        swalCustom.fire({
          text:"ยืนยันบันทึกข้อมูล",
          icon:"info",
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
        }).then((result) => {
          if(result.isConfirmed){
            axios(config)
            .then((response) => {
              swalCustom.fire({
                text:"สำเร็จ",
                icon: 'success',
                timer: 3000,
                confirmButtonText: "ปิด",
              }).then(() => {
                cash('#edit-member-modal').modal('hide')
                emit('update-state')
              });
            })
            .catch((error) => {
              swalCustom.fire({
                text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                icon: "warning",
                //timer: 3000, //timeOut for auto-close
                confirmButtonText: "ปิด",
              });
              console.log(error);
            });
          }
        })
      }
      else{
        axios(config)
        .then((response) => {
          emit('next-step', currStep.value)
        })
        .catch((error) => {
            swalCustom.fire({
                text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                icon: "warning",
                //timer: 3000, //timeOut for auto-close
                confirmButtonText: "ปิด",
            });
            console.log(error);
        });
      }
    }
    function skipStep(){
      emit('skip-step', currStep.value)
    }
    function closeWizardForm(){
      emit('close-wizard', currStep.value)
    }
    function prevStep(){
      emit('prev-step', currStep.value)
    }
    /*function normalizer(node) {
      return {
          id: `{"code": "${node.option.code}","desc": "${node.option.desc}"}`,
          label: node.option.desc
      }
    }*/
    // form.SUM_INCOME = computed({
    //   get() {
    //     return form.pri_occup_income + (form.sec_occup_income ? form.sec_occup_income: 0);
    //   },
    //   set(val){
    //     form.SUM_INCOME = val
    //   }
    // });
  watch(()=> props.cancelModal,(val)=>{
    if(val){
      Object.assign(form, formDefault)
      validate.value.$reset()
      validate_group.value.$reset()
    }
  })
  watch(()=> props.openModal,(val)=>{
    if(val){
      const dataEdit = JSON.parse(JSON.stringify(props.editData))
      // form.primary_occup = dataEdit.hasOwnProperty("primary_occup") && dataEdit.primary_occup ? Object.keys(dataEdit.primary_occup).length > 0 ? dataEdit.primary_occup : null : null
      
      form.primary_occup = dataEdit.primary_occup ? Object.keys(dataEdit.primary_occup).length > 0 ? dataEdit.primary_occup : null : null
      form.occup_status = dataEdit.occup_status?.valueOf() != undefined ? dataEdit.occup_status : null
      form.secondary_occup = dataEdit.secondary_occup?.length > 0 ? dataEdit.secondary_occup : []
      form.pri_occup_income = dataEdit.pri_occup_income?.valueOf() != undefined ? dataEdit.pri_occup_income : null
      form.sec_occup_income = dataEdit.sec_occup_income?.valueOf() != undefined  ? dataEdit.sec_occup_income : null
      form.get_subsidy = dataEdit.get_subsidy?.valueOf() != undefined ? dataEdit.get_subsidy : null
      form.subsidy_amount = dataEdit.subsidy_amount?.valueOf() != undefined ? dataEdit.subsidy_amount : null
      // form.SUM_INCOME = dataEdit.SUM_INCOME ? dataEdit.SUM_INCOME : 0
      form.SUM_EXPENDITURE = dataEdit.SUM_EXPENDITURE?.valueOf()
      form.saving = dataEdit.saving?.length > 0 ? dataEdit.saving : []
      form.SUM_SAVING = dataEdit.SUM_SAVING?.valueOf()
      form.have_debt = dataEdit.have_debt?.valueOf() != undefined ? dataEdit.have_debt : null
      form.debt = dataEdit.debt?.length > 0 ? dataEdit.debt : []
      form.SUM_DEBT = dataEdit.SUM_DEBT?.valueOf()
      form.expenditure = dataEdit.expenditure?.length > 0 ? dataEdit.expenditure : []
      form.asset = dataEdit.asset ? Object.keys(dataEdit.asset).length > 0 ?  dataEdit.asset : {land:[]} : {land:[]}
      if(form.primary_occup ? Object.keys(form.primary_occup).length > 0 : false){
        if(form.primary_occup.code == "OC9"){
          let index = data_primary_career.findIndex(x=>x.option.code == form.primary_occup.code)
          data_primary_career[index].option = form.primary_occup
        }
      }
      if(form.secondary_occup?.length > 0){
        form.secondary_occup.forEach(item => {
          let idx_data = data_secondary_career.findIndex(x => x.option.code == item.code);
          data_secondary_career[idx_data].option = item
        });
      }
      if(form.debt?.length > 0){
        form.debt.forEach(item => {
          let idx_data = formOption.debtOption.findIndex(x => x.type == item.type);
          formOption.debtOption[idx_data] = item
        });
      }
      if(form.saving?.length > 0){
        form.saving.forEach(item => {
          let idx_data_sv = data_saving.findIndex(x => x.option.code == item.code);
          data_saving[idx_data_sv].option = item
        });
      }
      if(form.expenditure?.length > 0){
        form.expenditure.forEach(item => {
          let idx_data_exp = data_expenditure.findIndex(x => x.option.code == item.code);
          data_expenditure[idx_data_exp].option = item
        });
        let idx_exp_other = form.expenditure.findIndex(x => x.code =="XP12")
        if(idx_exp_other != -1){
          formInput.expenditure_other = form.expenditure[idx_exp_other].expenditure_other
        }
      }
      if(form.asset ? Object.keys(form.asset).length > 0 : false){
        form.assetChoose = Object.keys(form.asset)
        if(form.asset.land?.length == 0){
          form.assetChoose.splice(form.assetChoose.indexOf("land"),1)
        }
        if(form.asset.land?.length > 0){
          form.asset.land.forEach(item => {
            let idx_data = formOption.propertyOption[0].choices.findIndex(x => x.type == item.type);
            formOption.propertyOption[0].choices[idx_data] = item
          });
        }
        if(form.assetChoose.includes("building")){
          formInput.building = form.asset.building
        }
        if(form.assetChoose.includes("livestock")){
          formInput.livestock = form.asset.livestock
        }
        if(form.assetChoose.includes("machinery")){
          formInput.machinery = form.asset.machinery
        }
      }
    }
  })
  function cancelModalButton(){
    validate.value.$reset()
    validate_group.value.$reset()
    emit('cancelButton')
  }

    return {
        form,
        formOption,
        addMoreItem,
        formInput,
        removeItem,
        nextStep,
        skipStep,
        closeWizardForm,
        prevStep,
        validate,
        validate_group,
        data_expenditure,
        data_saving,
        data_secondary_career,
        data_primary_career,
        cancelModalButton
        // primaryChange
    }
  },
})
</script>